import { gql } from '@apollo/client'

export const GET_CAMPAIGN_ACCEPTANCE_REPORT_FILE = gql`
  query campaignAcceptancesFile($campaignId: ID!) {
    campaignAcceptancesFile(campaignId: $campaignId) {
      url
    }
  }
`
